import { FC } from "react";

export const IconGlobe: FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5M15.5 8C15.5 3.85786 12.1421 0.5 8 0.5M15.5 8H0.5M8 15.5C3.85786 15.5 0.5 12.1421 0.5 8M8 15.5C10.2091 15.5 12 12.1421 12 8C12 3.85786 10.2091 0.5 8 0.5M8 15.5C5.79086 15.5 4 12.1421 4 8C4 3.85786 5.79086 0.5 8 0.5M8 15.5V0.5M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5M1.36505 4.5H14.635M1.36505 11.5H14.635"
      stroke="currentColor"
    />
  </svg>
);
